export const PROFILE_UPDATE_FIELDS_PATHS = {
  name: "/name",
  description: "/description",
  profile_url: "/profile_url",
  preferences: "/preferences",
  social: "/social",
  profile_picture: "/profile_picture",
  blocked_tags: "/blocked_tags",
};
